import { type ReactNode } from 'react'

import { BottomNav } from './bottom-nav'
import { Header } from './header'
import { SyncBanner } from './sync-banner'

/**
 * App shell for every authenticated route.
 *
 * Layout (top-to-bottom):
 *   ┌───────────────────────────┐
 *   │    SyncBanner (cond.)     │  conditional, sticky under notch
 *   ├───────────────────────────┤
 *   │           Header          │  56px (sticky)
 *   ├───────────────────────────┤
 *   │                           │
 *   │          content          │  flex, scrolls
 *   │                           │
 *   ├───────────────────────────┤
 *   │         Bottom nav        │  64px (fixed)
 *   └───────────────────────────┘
 *
 * The `SyncBanner` only renders when something is worth saying
 * (offline / syncing / error) so the layout doesn't lose vertical
 * pixels when the app is healthy. The bottom-nav is `fixed` so it
 * doesn't scroll with the content; the content area gets a
 * matching `pb-20` so the last card isn't hidden under the nav.
 */
interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-surface-muted">
      <SyncBanner />
      <Header />
      <main className="flex-1 pb-20 px-4 pt-4 max-w-screen-md mx-auto w-full">
        {children}
      </main>
      <BottomNav />
    </div>
  )
}
